import { useTranslation } from "react-i18next";

const keyI18n = "translations.admin.transparency";

export function usePeriodTitle() {
  const { t } = useTranslation();
  const months = t(`${keyI18n}.months`, { returnObjects: true }) as unknown as string[];

  return (month: number, year: number) =>
    t(`${keyI18n}.periodTitle`, { month: Array.isArray(months) ? months[month - 1] : month, year });
}
